import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

const overlayFade = trigger('overlayFade', [
  state('*', style({ opacity: 1 })),
  state('void', style({ opacity: 0, transform: 'translateY(20%)' })),

  transition('* <=> void', [animate('.1s ease-in')]),
]);

export { overlayFade };
